import { createContext, useContext } from 'react';

export interface PresentationEditingContextValue {
  /** Whether the current viewer may edit entity data on this surface. */
  canEdit: boolean;
  /** Household the edited entities belong to. */
  householdId: string;
  /**
   * Refresh the surface's slide data after a save. The single-entity export
   * preview passes its Apollo refetch; the presentation designer doesn't mount
   * this provider at all (its slides refresh via the context-data updater).
   */
  onRefresh: () => void;
}

const PresentationEditingContext =
  createContext<PresentationEditingContextValue | null>(null);

export const PresentationEditingProvider = PresentationEditingContext.Provider;

/**
 * Editing capability + refresh primitive for a surface that reuses the
 * presentation slide components outside the Client Presentation Designer — i.e.
 * the single-entity export preview. Returns null inside the designer (and the
 * read-only print/export paths), where consumers fall back to the designer
 * context. This is what lets the shared entity-diagram editing chrome work on
 * the preview without coupling it to the designer's context/refetch.
 */
export function usePresentationEditingContext(): PresentationEditingContextValue | null {
  return useContext(PresentationEditingContext);
}
